<div class="w-full h-full relative aligner flex-col" [attr.data-test]="'list-view-grid'">
  <div class="absolute top-0 z-10 w-full" *ngIf="!hideLoader" [hidden]="!state.isLoading">
    <mat-progress-bar mode="indeterminate" class="w-full"></mat-progress-bar>
  </div>

  <ng-container *ngIf="state.initialized">
    <ag-grid-angular
      class="ag-theme-material-datos"
      @appearDisappear
      [hidden]="!state.hasData"
      [gridOptions]="gridOptions"
      [columnDefs]="columnDefs"
      [rowData]="state.data"
      [components]="frameworkComponents"
      (gridReady)="onGridReady($event)"
      (gridSizeChanged)="onGridSizeChanged()"
      (rowClicked)="rowClicked($event)"
      (rowDoubleClicked)="rowDoubleClicked($event)"
      (selectionChanged)="gridSelectionChanged.emit($event)"
      (cellClicked)="cellClicked.emit($event)"
    >
    </ag-grid-angular>

    <div class="empty-table" *ngIf="!state.hasData" @appearDisappear data-test="list-view-grid-empty-table">
      <img *ngIf="!messages?.noDataImgSrc && !hideNoDataImg" src="assets/images/not-available/no-insights.svg" />
      <img *ngIf="messages?.noDataImgSrc && !hideNoDataImg" [src]="messages?.noDataImgSrc" />

      <div class="empty-table-header">{{ messages?.noDataHeader || 'No data' }}</div>
      <div class="empty-table-body">
        {{ messages?.noDataBody || '' }}
      </div>
      <div matTooltip *ngIf="canAdd && messages?.addButtonLabel">
        <button
          mat-raised-button
          color="primary"
          type="button"
          (click)="add.emit()"
          [attr.data-test]="'list-view-grid-button-add-item'"
          [y42Permission]="state.addPermissionAllowed"
          [permissionTooltip]="messages?.addPermissionAllowedButtonTooltip || ''"
        >
          {{ messages?.addButtonLabel || 'Add item' }}
        </button>
      </div>
    </div>
  </ng-container>
</div>
